<template>
  <!-- What ASport does: short cards, one per area, each opening its section on /features. The clicks
       tell us what visitors actually came for (Ansis, 2026-10-25). -->
  <v-container id="features" fluid class="py-14 as-home-section as-home-section--grey">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="9">
        <h2 class="as-home-heading">{{ $t('pages.home-view.features.title') }}</h2>
        <p class="as-home-subheading">{{ $t('pages.home-view.features.subtitle') }}</p>

        <feature-area-cards :location="location" collapse-on-phone />

        <div class="text-center mt-6">
          <router-link :to="featuresUrl" class="as-home-text-link" @click.native="onAllFeaturesClick">
            {{ $t('pages.home-view.features.all-link') }} →
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import urlUtil from '@/js/utils/urlUtil'
import { MainPath } from '@/router/mainPaths'
import FeatureAreaCards from '@/domains/website/components/FeatureAreaCards.vue'
import { trackWebsiteEvent, WebsiteCta, WebsiteEvent, WebsiteLocation } from '@/domains/website/websiteTracking'

export default {
  name: 'HomeFeaturesSection',
  components: { FeatureAreaCards },
  data: () => ({
    location: WebsiteLocation.FEATURES
  }),
  computed: {
    featuresUrl () {
      return urlUtil.getLocalisedUrl('/' + MainPath.FEATURES)
    }
  },
  methods: {
    onAllFeaturesClick () {
      trackWebsiteEvent(this.$gtag, WebsiteEvent.CTA_CLICK, { cta: WebsiteCta.ALL_FEATURES, location: this.location })
    }
  }
}
</script>

